var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTextMessage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0063ff",
    fillRule: "evenodd",
    d: "M8.384 18.151a1 1 0 01.767.056A7.382 7.382 0 0012.5 19a7.502 7.502 0 006.707-4.15A7.38 7.38 0 0020 11.502l.002-.448C19.792 7.248 16.752 4.21 13 4h-.503a7.385 7.385 0 00-3.35.795A7.5 7.5 0 005 11.503a7.38 7.38 0 00.793 3.346 1 1 0 01.056.767L4.58 19.42l3.803-1.268zM22 11.5a9.376 9.376 0 01-1.005 4.248A9.5 9.5 0 0112.503 21a9.38 9.38 0 01-3.87-.824L3.317 21.95a1 1 0 01-1.265-1.265l1.773-5.318a9.498 9.498 0 014.424-12.36A9.377 9.377 0 0112.5 2l.555.002C17.88 2.268 21.732 6.12 22 11v.499z"
  })));
}
export default SvgIconTextMessage;